import Vue from 'vue'
import VtLockToggle from '@/components/common/VtLockToggle.vue'
Vue.component('VtLockToggle', VtLockToggle)
